<template>
  <div>
    <v-flex>
      <v-flex>
        <img height="35px" src="../../../assets/logo.png" />
      </v-flex>
      <h2 class="h2-header mt-2">{{ $t("pageHeader.changePassword") }}</h2>
    </v-flex>
    <v-text-field
      v-model.trim="password"
      :append-icon="showPassword ? 'visibility_off' : 'visibility'"
      :type="showPassword ? 'text' : 'password'"
      :label="$t('labels.password')"
      :error-messages="passwordErrors"
      @input="$v.password.$touch()"
      counter="counter"
      @click:append="showPassword = !showPassword"
    >
    </v-text-field>
    <v-text-field
      v-model.trim="confirmPassword"
      :append-icon="showConfirmPassword ? 'visibility_off' : 'visibility'"
      :type="showConfirmPassword ? 'text' : 'password'"
      :label="$t('labels.confirmPassword')"
      :error-messages="confirmPasswordErrors"
      @input="$v.confirmPassword.$touch()"
      counter="counter"
      @click:append="showConfirmPassword = !showConfirmPassword"
    >
    </v-text-field>
    <v-layout class="mt-4" row justify-space-between="justify-space-between">
      <v-btn text to="/login">Sign Up</v-btn>
      <v-btn @click="submit" :loading="isLoading" color="primary" large>{{
        $t("buttons.submit")
      }}</v-btn>
    </v-layout>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import publicService from "../../../api/public";

const { validationMixin } = require("vuelidate");
const { required, sameAs } = require("vuelidate/lib/validators");

export default {
  name: "change-password",
  data() {
    return {
      isLoading: false,
      showPassword: false,
      showConfirmPassword: false,
      confirmPassword: null,
      password: null,
      token: null
    };
  },
  created() {
    if (!this.$route.query) return this.$router.push("/login");
    this.token = this.$route.query.token;
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toasted.error("Invalid Input", {
          position: "top-right",
          showHideTransition: "slide",
          duration: 2000
        });
      } else {
        this.isLoading = true;
        this.$Progress.start();
        let dataSend = {
          password: this.password,
          token: this.token
        };
        console.log("dataSend", dataSend);
        publicService
          .changePassword(dataSend)
          .then(response => {
            console.log('receklj;laksjdf;lkasjdf', response)
            this.$Progress.finish();
            this.isLoading = false;
            this.$swal("Change Password", "Password Save successfully", "success")
            // this.$toasted.success(`Password Save successfully`, {
            //   position: "top-right",
            //   showHideTransition: "slide",
            //   icon: "check",
            //   duration: 2000
            // });
            // set the organization id or ask for the selection
            // console.log("response test", response);
            this.$router.push({ path: "/login" });
          })
          .catch(error => {
            this.isLoading = false;
            this.$Progress.finish();
            console.log("change password", error);
            this.$swal("Change Password", "Token Expair, try again later", "error").then(() => {
              this.$router.push({ path: "/forgotPassword" });
            });
          });
      }
    }
  },
  computed: {
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.confirmPassword.$dirty) return errors;
      if (!this.$v.confirmPassword.sameAsPassword)
        errors.push(this.$t("validations.passwordDoesNotMatch"));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("Password is required.");
      return errors;
    }
  },
  mixins: [validationMixin],
  validations: {
    confirmPassword: {
      sameAsPassword: sameAs("password")
    },
    password: {
      required
    }
  }
};
</script>
